<template>
  <div class="RouteContainer">
    <app-gallery-section :sectionIndex="3"/>
  </div>
</template>

<script>
import appGallerySection from './../gallery/gallery-section'
export default {
  name: 'theBenefitsOfWolves',

  components: {
    appGallerySection
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/the-benefits-of-wolves.vue